const DEV_ORIGIN = 'http://quickasyst-frontend-dev-994667444.ap-south-1.elb.amazonaws.com';
const COMBINED_APP_ORIGINS: Record<string, string> = {
  dev: DEV_ORIGIN,
  development: DEV_ORIGIN,
  staging: 'https://quickasyst-app-staging.quickasyst.com',
  prod: 'https://www.quickasyst.com',
  production: 'https://www.quickasyst.com',
};

/** The destination belongs to this admin deployment, never to link/user input. */
export function buildDesktopReferralUrl(_code: string): string {
  const environment = process.env.REACT_APP_ENVIRONMENT?.trim().toLowerCase() || '';
  const configured = process.env.REACT_APP_COMBINED_APP_URL?.trim() || COMBINED_APP_ORIGINS[environment];
  if (!configured) throw new Error('Combined app URL is not configured for this environment.');
  const origin = new URL(configured);
  const local = ['localhost', '127.0.0.1', '[::1]'].includes(origin.hostname);
  if (origin.username || origin.password || (origin.protocol !== 'https:' &&
      !(origin.protocol === 'http:' && (local || origin.origin === DEV_ORIGIN)))) {
    throw new Error('Combined app URL must use HTTPS, localhost, or the configured development load balancer.');
  }
  // Open Buy signup and load the locked referral from Branch click metadata.
  const destination = new URL('/', origin.origin);
  destination.searchParams.set('branch_referral', '1');
  destination.searchParams.set('auth', 'signup');
  destination.searchParams.set('qa_mode', 'buy');
  return destination.toString();
}

/** Existing links can carry a desktop override without changing their mobile data. */
export function withDesktopReferralDestination(link: string, code?: string): string {
  if (!link) return link;
  let url: URL;
  try { url = new URL(link); } catch { return link; }
  // Some older affiliate records point at an unserved quickasyst.app domain.
  // Rebuild those as Branch links so both desktop and mobile routing still work.
  if (url.hostname === 'quickasyst.app' && ['http:', 'https:'].includes(url.protocol)) {
    const match = /^\/ref\/([a-z0-9_-]+)\/?$/i.exec(url.pathname);
    if (!match) return link;
    const legacyCode = code?.trim() || match[1];
    const live = process.env.REACT_APP_BRANCH_IO_API_KEY?.startsWith('key_live_') ||
      (!process.env.REACT_APP_BRANCH_IO_API_KEY && /^(prod|production)$/i.test(process.env.REACT_APP_ENVIRONMENT || ''));
    url = new URL(live ? 'https://quickasyst.app.link/' : 'https://quickasyst.test-app.link/');
    url.searchParams.set('qac', legacyCode);
    url.searchParams.set('referralCode', legacyCode);
    url.searchParams.set('$android_deeplink_path', process.env.REACT_APP_ANDROID_DEEPLINK_PATH || 'quickasyst://');
    url.searchParams.set('$ios_deeplink_path', process.env.REACT_APP_IOS_DEEPLINK_PATH || 'quickasyst://');
    const androidUrl = process.env.REACT_APP_ANDROID_URL?.trim();
    const iosUrl = process.env.REACT_APP_IOS_URL?.trim();
    if (androidUrl) url.searchParams.set('$android_url', androidUrl);
    if (iosUrl) url.searchParams.set('$ios_url', iosUrl);
    code = legacyCode;
  }
  if (url.protocol !== 'https:' || !['quickasyst.app.link', 'quickasyst.test-app.link'].includes(url.hostname)) return link;
  let referralCode = code?.trim() || url.searchParams.get('qac');
  try { referralCode ||= decodeURIComponent(url.pathname.slice(1)); } catch { return link; }
  if (!referralCode) return link;
  url.searchParams.set('$desktop_url', buildDesktopReferralUrl(referralCode));
  url.searchParams.set('$desktop_deepview', 'false');
  url.searchParams.set('$desktop_web_only', 'true');
  return url.toString();
}
